import AddClientInfoModal from './add-client-info-modal.vue'
export default AddClientInfoModal
